/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {AsyncPipe, NgIf} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NbButtonModule, NbInputModule, NbWindowRef} from '@nebular/theme';
import {ForgotService} from 'compob2b-auth';
import {ApiResponse, BaseComponent, HTTP_STATUS} from 'compob2b-libs';
import {BehaviorSubject} from 'rxjs';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-popup-forgot',
    templateUrl: './forgot.component.html',
    imports: [
        ReactiveFormsModule,
        NbButtonModule,
        NgIf,
        AsyncPipe,
        NbInputModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit {
  serverError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  userNotFoundError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  success: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(protected readonly windowRef: NbWindowRef,
              readonly forgotService: ForgotService) {
    super();
  }

  close(): void {
    this.windowRef.close();
  }

  forgotForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
  });

  ngOnInit() {
    this.serverError.next(false);
    this.userNotFoundError.next(false);
    this.success.next(false);
  }

  onSubmit() {
    if (this.forgotForm.valid) {
      this.loading = true;
      this.forgotService.remind(this.forgotForm.value).pipe(take(1)).subscribe(
        (response: ApiResponse<string>) => {
          this.loading = false;
          this.userNotFoundError.next(false);
          this.serverError.next(false);
          this.success.next(true);
        },
        (error: HttpErrorResponse) => {
          this.loading = false;
          this.success.next(false);
          if (error.status === HTTP_STATUS.NOT_FOUND) {
            this.userNotFoundError.next(true);
          } else {
            this.serverError.next(true);
          }
        }
      );
    }
  }
}
